// Threshold represents the minimum distance to run in order to close the Drawer on drag.
const thresholdMin = 50;
const thresholdMax = 200;
// percentage of the drawer (0.5 = 50%)
const thresholdPercentage = 0.5;

export { thresholdMin, thresholdMax, thresholdPercentage };
